import React, { useEffect, useRef, useCallback, ChangeEvent, useState } from 'react';
import { useField } from '@unform/core';
import {
  makeStyles,
  createStyles,
  Card,
  CardHeader,
  CardContent,
  Theme,
  Button,
} from '@material-ui/core';
import Colors from '../Colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: { marginBottom: theme.spacing(2) },
    cardHeader: {
      backgroundColor: Colors.secundary,
      color: Colors.tertiary,
      paddingBottom: 5,
      paddingTop: 5,
    },
    cardContent: {
      paddingTop: 5,
    },
    fileInput: {
      display: 'none',
    },
    fileName: {
      marginLeft: 10,
    },
  }),
);

interface IProps {
  nameInput: string;
}
type InputProps = JSX.IntrinsicElements['input'] & IProps;

const FileSelect: React.FC<InputProps> = ({ name, nameInput, ...rest }) => {
  const classes = useStyles();

  const inputRef = useRef<HTMLInputElement>(null);
  const { fieldName, defaultValue, registerField } = useField(nameInput);

  const [csvFile, setCsvFile] = useState(defaultValue);

  const handlePreview = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    setCsvFile(file);
  }, []);

  const buttonClick = () => {
    inputRef.current?.click();
  };

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'files[0]',
    });
  }, [fieldName, registerField]);

  return (
    <Card className={classes.root}>
      <CardHeader
        title={name}
        titleTypographyProps={{ style: { fontSize: 18 } }}
        className={classes.cardHeader}
      />
      <CardContent className={classes.cardContent}>
        <input
          id={fieldName}
          ref={inputRef}
          name={nameInput}
          {...rest}
          type="file"
          onChange={handlePreview}
          className={classes.fileInput}
        />
        <Button variant="outlined" component="span" onClick={buttonClick}>
          Escolha um arquivo
        </Button>
        <span className={classes.fileName}>{csvFile ? csvFile.name : ''}</span>
      </CardContent>
    </Card>
  );
};

export default FileSelect;
